import { useEffect, useState, useCallback } from "react";
import Sidebar from "../components/Sidebar";
import MobileHeader from "../components/MobileHeader";
import { supabase } from "../supabase";

const BOT_TOKEN = "8628392776:AAEIkaTzeyZNhWz7IY0ZCzrNGPs-hJcsweg";
const ADMIN_CHAT_ID = "198233634";

const EVENT_CONFIG = {
  SevereSpeedingStarted: {
    label: "Severe speeding",
    color: "#a32d2d",
    bg: "#fcebeb",
    badge: "Severe",
  },
  SevereSpeedingEnded: {
    label: "Severe speeding ended",
    color: "#3b6d11",
    bg: "#eaf3de",
    badge: "Resolved",
  },
  SpeedingEventStarted: {
    label: "Speeding",
    color: "#854f0b",
    bg: "#faeeda",
    badge: "Speeding",
  },
  SpeedingEventEnded: {
    label: "Speeding ended",
    color: "#3b6d11",
    bg: "#eaf3de",
    badge: "Resolved",
  },
  EngineFaultOn: {
    label: "Engine fault",
    color: "#a32d2d",
    bg: "#fcebeb",
    badge: "Fault",
  },
  EngineFaultOff: {
    label: "Engine fault cleared",
    color: "#3b6d11",
    bg: "#eaf3de",
    badge: "Cleared",
  },
  GatewayUnplugged: {
    label: "Gateway unplugged",
    color: "#854f0b",
    bg: "#faeeda",
    badge: "Device",
  },
  GeofenceEntry: {
    label: "Geofence entry",
    color: "#185fa5",
    bg: "#e6f1fb",
    badge: "Geofence",
  },
  GeofenceExit: {
    label: "Geofence exit",
    color: "#185fa5",
    bg: "#e6f1fb",
    badge: "Geofence",
  },
  DvirSubmitted: {
    label: "DVIR submitted",
    color: "#3b6d11",
    bg: "#eaf3de",
    badge: "DVIR",
  },
  PredictiveMaintenanceAlert: {
    label: "Maintenance alert",
    color: "#854f0b",
    bg: "#faeeda",
    badge: "Maintenance",
  },
  RouteStopArrival: {
    label: "Stop arrival",
    color: "#185fa5",
    bg: "#e6f1fb",
    badge: "Trip",
  },
  RouteStopDeparture: {
    label: "Stop departure",
    color: "#185fa5",
    bg: "#e6f1fb",
    badge: "Trip",
  },
  Ping: { label: "Ping", color: "#888", bg: "#f0f0f0", badge: "Ping" },
  AlertIncident: {
    label: "Speed alert",
    color: "#854f0b",
    bg: "#faeeda",
    badge: "Alert",
  },
};

const FILTERS = [
  "All",
  "Speeding",
  "Engine",
  "Geofence",
  "Trips",
  "Maintenance",
];

const getIcon = (eventType) => {
  if (eventType?.includes("Speeding"))
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
    );
  if (eventType?.includes("Engine"))
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="2" y="7" width="20" height="14" rx="2" />
        <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
        <line x1="12" y1="12" x2="12" y2="16" />
        <line x1="10" y1="14" x2="14" y2="14" />
      </svg>
    );
  if (eventType?.includes("Geofence"))
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
    );
  if (eventType?.includes("Route"))
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="1" y="3" width="15" height="13" rx="1" />
        <path d="M16 8h4l3 5v4h-7V8z" />
        <circle cx="5.5" cy="18.5" r="2.5" />
        <circle cx="18.5" cy="18.5" r="2.5" />
      </svg>
    );
  if (eventType?.includes("Maintenance"))
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
      </svg>
    );
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  );
};

const matchFilter = (eventType, filter) => {
  if (filter === "All") return true;
  if (filter === "Speeding") return eventType?.includes("Speeding");
  if (filter === "Engine")
    return eventType?.includes("Engine") || eventType?.includes("Gateway");
  if (filter === "Geofence") return eventType?.includes("Geofence");
  if (filter === "Trips")
    return eventType?.includes("Route") || eventType?.includes("Dvir");
  if (filter === "Maintenance") return eventType?.includes("Maintenance");
  return true;
};

const timeAgo = (ts) => {
  if (!ts) return "—";
  const diff = Math.floor((Date.now() - new Date(ts).getTime()) / 1000);
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};

const sendTelegramAlert = async (event) => {
  const cfg = EVENT_CONFIG[event.event_type] || { label: event.event_type };
  const driverPart = event.driver_name ? `*Driver:* ${event.driver_name}` : "";
  const vehiclePart = event.vehicle_name
    ? `*Vehicle:* ${event.vehicle_name}`
    : "";
  const details = [driverPart, vehiclePart].filter(Boolean).join("\n");
  const text = `🚨 *Fleet Alert — ${cfg.label}*\n\n${details}\n\n_${new Date(
    event.occurred_at
  ).toLocaleString()}_`;
  try {
    await fetch(`https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        chat_id: ADMIN_CHAT_ID,
        text,
        parse_mode: "Markdown",
      }),
    });
  } catch (e) {
    console.error("Telegram alert error:", e);
  }
};

export default function Alerts() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("All");
  const [lastId, setLastId] = useState(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchEvents = useCallback(
    async (notify = false) => {
      const { data } = await supabase
        .from("samsara_events")
        .select("*")
        .neq("event_type", "Ping")
        .order("created_at", { ascending: false })
        .limit(100);
      if (data) {
        // Send Telegram for new events
        if (notify && lastId && data.length > 0 && data[0].id !== lastId) {
          const newEvents = [];
          for (const e of data) {
            if (e.id === lastId) break;
            newEvents.push(e);
          }
          for (const e of newEvents) {
            await sendTelegramAlert(e);
          }
        }
        setEvents(data);
        if (data.length > 0) setLastId(data[0].id);
        setLoading(false);
      }
    },
    [lastId]
  );

  useEffect(() => {
    fetchEvents(false);
    const interval = setInterval(() => fetchEvents(true), 30000);
    return () => clearInterval(interval);
  }, [fetchEvents]);

  const filtered = events.filter((e) => matchFilter(e.event_type, filter));

  const todayEvents = events.filter((e) => {
    const d = new Date(e.created_at);
    const now = new Date();
    return d.toDateString() === now.toDateString();
  });

  const speedingCount = todayEvents.filter((e) =>
    e.event_type?.includes("Speeding")
  ).length;
  const engineCount = todayEvents.filter((e) =>
    e.event_type?.includes("Engine")
  ).length;
  const tripCount = todayEvents.filter((e) => e.event_type?.includes("Route"))
    .length;

  const btnStyle = (bg, color) => ({
    background: bg,
    color,
    fontSize: "13px",
    fontWeight: "500",
    padding: "8px 18px",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    fontFamily: "inherit",
  });

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#f8f8f8" }}>
      {!isMobile && <Sidebar />}
      <div style={{ flex: 1, minWidth: 0 }}>
        {isMobile && <MobileHeader title="Alerts" />}

        {/* Header */}
        <div
          style={{
            background: "#fff",
            borderBottom: "0.5px solid #e8e8e8",
            padding: "12px 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="t-page-title">Fleet Alerts</div>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <div
                style={{
                  width: "7px",
                  height: "7px",
                  borderRadius: "50%",
                  background: "#3a9e5f",
                }}
              />
              <span style={{ fontSize: "12px", color: "#6b7280" }}>
                Live · refreshes every 30s
              </span>
            </div>
            <button
              onClick={() => fetchEvents(false)}
              style={btnStyle("#f0f0f0", "#555")}
            >
              ↻ Refresh
            </button>
          </div>
        </div>

        <div
          style={{
            padding: isMobile ? "12px" : "24px",
            maxWidth: "960px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          {/* Stats */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: "12px",
            }}
          >
            {[
              {
                label: "Today's alerts",
                value: todayEvents.length,
                color: "#111",
              },
              { label: "Speeding", value: speedingCount, color: "#854f0b" },
              { label: "Engine faults", value: engineCount, color: "#a32d2d" },
              { label: "Trips", value: tripCount, color: "#3b6d11" },
            ].map(({ label, value, color }) => (
              <div
                key={label}
                style={{
                  background: "#fff",
                  border: "0.5px solid #e8e8e8",
                  borderRadius: "12px",
                  padding: "14px 16px",
                }}
              >
                <div className="t-label" style={{ marginBottom: "6px" }}>
                  {label}
                </div>
                <div style={{ fontSize: "22px", fontWeight: "600", color }}>
                  {value}
                </div>
              </div>
            ))}
          </div>

          {/* Filters */}
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            {FILTERS.map((f) => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                style={{
                  background: filter === f ? "#1a1e1c" : "#fff",
                  color: filter === f ? "#fff" : "#555",
                  border: `0.5px solid ${filter === f ? "#1a1e1c" : "#e8e8e8"}`,
                  borderRadius: "6px",
                  padding: "5px 14px",
                  fontSize: "12px",
                  fontWeight: "500",
                  cursor: "pointer",
                  fontFamily: "inherit",
                }}
              >
                {f}
              </button>
            ))}
          </div>

          {/* Events list */}
          <div
            style={{
              background: "#fff",
              border: "0.5px solid #e8e8e8",
              borderRadius: "12px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                padding: "14px 20px",
                background: "#fafafa",
                borderBottom: "0.5px solid #e8e8e8",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div className="t-table-header">
                {filtered.length}{" "}
                {filter === "All" ? "total" : filter.toLowerCase()} events
              </div>
            </div>

            {loading ? (
              <div
                style={{ padding: "40px", textAlign: "center" }}
                className="t-body"
              >
                Loading alerts...
              </div>
            ) : filtered.length === 0 ? (
              <div
                style={{ padding: "40px", textAlign: "center" }}
                className="t-body"
              >
                No alerts yet — events will appear here as they come in
              </div>
            ) : (
              filtered.map((event, i) => {
                const cfg = EVENT_CONFIG[event.event_type] || {
                  label: event.event_type,
                  color: "#888",
                  bg: "#f0f0f0",
                  badge: event.event_type,
                };
                return (
                  <div
                    key={event.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "14px",
                      padding: "14px 20px",
                      borderBottom:
                        i < filtered.length - 1
                          ? "0.5px solid #f0f0f0"
                          : "none",
                      background: i % 2 === 0 ? "#fff" : "#fafafa",
                    }}
                  >
                    {/* Icon */}
                    <div
                      style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        background: cfg.bg,
                        color: cfg.color,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      {getIcon(event.event_type)}
                    </div>

                    {/* Body */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div className="t-name" style={{ marginBottom: "2px" }}>
                        {cfg.label}
                      </div>
                      <div className="t-label" style={{ color: "#9ca3af" }}>
                        {(() => {
                          const parts = [];
                          if (event.vehicle_name)
                            parts.push(event.vehicle_name);
                          if (event.driver_name) parts.push(event.driver_name);
                          const speed =
                            event.payload?.data?.conditions?.[0]?.details
                              ?.speed;
                          if (speed) {
                            const vehicleName =
                              speed.vehicle?.name || speed.vehicle?.serial;
                            if (vehicleName && !parts.includes(vehicleName))
                              parts.push(vehicleName);
                            const mph = Math.round(
                              speed.currentSpeedKilometersPerHour * 0.621371
                            );
                            const threshold = Math.round(
                              speed.thresholdSpeedKilometersPerHour * 0.621371
                            );
                            parts.push(
                              `${mph} mph · threshold ${threshold} mph`
                            );
                          }
                          if (event.payload?.data?.address?.name)
                            parts.push(event.payload.data.address.name);
                          if (event.payload?.data?.address?.formattedAddress)
                            parts.push(
                              event.payload.data.address.formattedAddress
                            );
                          const url = event.payload?.data?.incidentUrl;
                          return parts.length > 0 ? (
                            <span>
                              {parts.join(" · ")}
                              {url && (
                                <a
                                  href={url}
                                  target="_blank"
                                  rel="noreferrer"
                                  style={{
                                    marginLeft: "6px",
                                    color: "#3a9e5f",
                                    fontSize: "11px",
                                  }}
                                >
                                  View →
                                </a>
                              )}
                            </span>
                          ) : (
                            "No info"
                          );
                        })()}
                      </div>
                    </div>

                    {/* Right */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        gap: "6px",
                        flexShrink: 0,
                      }}
                    >
                      <div style={{ fontSize: "11px", color: "#9ca3af" }}>
                        {timeAgo(event.occurred_at || event.created_at)}
                      </div>
                      <div
                        style={{
                          fontSize: "10px",
                          fontWeight: "500",
                          padding: "2px 8px",
                          borderRadius: "20px",
                          background: cfg.bg,
                          color: cfg.color,
                        }}
                      >
                        {cfg.badge}
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
